





























































import { get } from 'lodash';
import moment, { Moment } from 'moment';
import { MaritimeLocation } from 'sp-common/src/types/opti/MaritimeLocation';
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';

import { OptiState } from '@/store/modules/opti';
import { checkLocationsCompatibility } from '@/utils/opti/checkLocationsCompatibility';

import { stringifyViolations } from '../../utils/opti/stringifyViolations';

const opti = namespace('opti');
@Component
export default class LocationDestination extends Vue {
  @opti.Getter importInstallations!: OptiState['installations'];
  @opti.State startContract!: OptiState['startContract'];
  @opti.State destinationContracts!: OptiState['destinationContracts'];
  @opti.State profitResults!: OptiState['profitResults'];
  @opti.State voyages!: OptiState['voyages'];
  @opti.State((state) => state.display.activeDestination)
  activeDestination!: OptiState['display']['activeDestination'];
  @opti.Action calculateProfits!: any;
  @opti.Mutation setDestinationDates!: any;
  @opti.Mutation setDestinationLocation!: any;
  @opti.Mutation removeLastDestination!: any;
  loading = false;
  searchTerm = '';

  get selectedDestination() {
    return this.destinationContracts[this.activeDestination];
  }
  get selectedLocation() {
    return this.selectedDestination && this.selectedDestination.location
      ? this.displayLocation(this.selectedDestination.location)
      : null;
  }
  get startDate() {
    return this.selectedDestination.startDate
      ? moment(this.selectedDestination.startDate)
      : undefined;
  }
  get endDate() {
    return this.selectedDestination.endDate
      ? moment(this.selectedDestination.endDate)
      : undefined;
  }

  get importInstallationsFiltered() {
    if (!this.searchTerm.length) {
      return [];
    }
    const destinationIds = this.destinationContracts.map(
      (contract) => contract.location && contract.location.id
    );
    return this.importInstallations
      .filter((loc) => loc.id !== this.startingLocation!.id)
      .filter((loc) => !destinationIds.includes(loc.id))
      .map((loc) => {
        const compatible = checkLocationsCompatibility(
          this.startingLocation!,
          loc
        );
        return { ...loc, compatible };
      })
      .map((loc) => {
        return {
          ...loc,
          displayName: this.displayLocation(loc),
        };
      })
      .filter((loc) => {
        return `${loc.displayName} ${loc.portName} ${loc.zoneName}`
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      })
      .sort((locA, locB) => +locB.compatible - +locA.compatible);
  }
  get startingLocation() {
    return this.startContract.location!;
  }
  get startContractEndDate() {
    return this.startContract.endDate;
  }

  get valid() {
    const hasLocation = !!this.selectedLocation;
    const hasStartDate = !!this.startDate;
    const hasEndDate = !!this.endDate;

    return hasLocation && hasStartDate && hasEndDate;
  }

  get hasConstraintViolations() {
    const profitResult =
      this.profitResults && this.profitResults[this.activeDestination];
    const constraintViolations = get(profitResult, 'constraintViolations');
    const hasConstraintViolations =
      constraintViolations && constraintViolations.length;
    return !!hasConstraintViolations;
  }

  get hasVoyage() {
    const hasVoyage = this.voyages[this.activeDestination];
    return !!hasVoyage;
  }

  displayLocation(location: MaritimeLocation): string {
    return `${location.shortName} (${location.name})`;
  }

  handleSearch(value: string) {
    return (this.searchTerm = value);
  }

  disabledDate(date: Moment) {
    return date.isSameOrBefore(moment(this.startContractEndDate!));
  }
  selectLocation(value: string) {
    const location = this.importInstallations.find((loc) => loc.id === value);

    if (
      location &&
      !checkLocationsCompatibility(this.startingLocation, location)
    ) {
      this.$message.warning(
        `${this.startingLocation.shortName} may be incompatible with ${location.shortName}`
      );
    }
    this.setDestinationLocation({
      payload: location,
      index: this.activeDestination,
    });
    this.searchTerm = '';
    this.backendValidate();
  }

  async backendValidate() {
    if (!this.valid) return;
    this.loading = true;
    const cancelLoading = this.$message.loading('Validating..', 0);
    await this.calculateProfits().then(cancelLoading);
    this.checkConstraintViolation();
    this.loading = false;
  }
  changeDates([startDate, endDate]: Moment[]) {
    this.setDestinationDates({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      index: this.activeDestination,
    });
    this.backendValidate();
  }

  checkConstraintViolation() {
    const violations =
      this.profitResults &&
      this.profitResults[this.activeDestination].constraintViolations;
    if (violations && violations.length) {
      const violationText = stringifyViolations(violations);
      this.$message.error(violationText, 5);
    }
  }

  next() {
    this.$router.replace('3');
  }

  cancel() {
    this.removeLastDestination();
    this.$router.replace('3');
  }
}
